import React from "react";

import { appRoutes } from "../../lib/appRoutes";
import { EllipsisTooltipRouterLink } from "../../lib/core_components/EllipsisTooltip";
import UIcon from "../../lib/icons/untitled_ui/UIcon";
import { Flex, Text } from "../../styles/utility-components";
import { EmptyLogoImage, LogoImage, TableCell } from "./TableCellStyles";

export interface BuyerRecord {
  id: string;
  name?: string | null;
  logoUrl?: string | null;
  isCustom?: boolean;
}

export interface BuyerWithLogoCellProps {
  buyers: BuyerRecord[];
  minWidth?: number;
}

export const BuyerWithLogoCell: React.FC<BuyerWithLogoCellProps> = ({ buyers, minWidth = 200 }) => {
  if (!buyers || buyers.length === 0) {
    return <TableCell minWidth={minWidth}>-</TableCell>;
  }
  const buyer = buyers[0];
  return (
    <TableCell minWidth={minWidth}>
      <Flex alignItems="center" gap={8} minWidth={minWidth}>
        {buyer.logoUrl ? (
          <LogoImage src={buyer.logoUrl} alt={`${buyer.name || "Buyer"} logo`} />
        ) : (
          <EmptyLogoImage>
            <UIcon icon="wallet02" size={12} ariaLabel="Buyer logo placeholder" />
          </EmptyLogoImage>
        )}
        {buyer.isCustom ? (
          <Text ellipsis>{buyer.name ?? "--"}</Text>
        ) : (
          <EllipsisTooltipRouterLink
            fullText={buyer.name ?? "--"}
            linkText={buyer.name ?? "--"}
            linkProps={{ ...appRoutes.buyerDetail(buyer.id) }}
          />
        )}
      </Flex>
    </TableCell>
  );
};
